import React from 'react';

import { Icon } from '../icons';

export const CampaignDailySessionIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 25 25" fill={color} style={style}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.5 6.00003C4.80964 6.00003 4.25 6.55967 4.25 7.25003V11.25C4.25 11.6642 3.91421 12 3.5 12C3.08579 12 2.75 11.6642 2.75 11.25V7.25003C2.75 5.73125 3.98122 4.50003 5.5 4.50003H7.5C7.91421 4.50003 8.25 4.83582 8.25 5.25003C8.25 5.66424 7.91421 6.00003 7.5 6.00003H5.5Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 2.49997C7.91421 2.49997 8.25 2.83576 8.25 3.24997V7.24997C8.25 7.66418 7.91421 7.99997 7.5 7.99997C7.08579 7.99997 6.75 7.66418 6.75 7.24997V3.24997C6.75 2.83576 7.08579 2.49997 7.5 2.49997Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.25 5.25003C18.25 4.83582 18.5858 4.50003 19 4.50003H19.5C21.0188 4.50003 22.25 5.73125 22.25 7.25003V11.25C22.25 11.6642 21.9142 12 21.5 12C21.0858 12 20.75 11.6642 20.75 11.25V7.25003C20.75 6.55967 20.1904 6.00003 19.5 6.00003H19C18.5858 6.00003 18.25 5.66424 18.25 5.25003Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4999 9.57501C12.747 9.57501 12.9743 9.70995 13.0925 9.92683L14.341 12.216L16.9039 12.696C17.1467 12.7414 17.3453 12.9159 17.4217 13.1508C17.498 13.3858 17.4399 13.6437 17.2702 13.8232L15.4788 15.7179L15.8144 18.3037C15.8461 18.5487 15.7416 18.7915 15.5417 18.9367C15.3419 19.0819 15.0787 19.1063 14.8555 19.0004L12.4999 17.8822L10.1444 19.0004C9.9212 19.1063 9.658 19.0819 9.45815 18.9367C9.2583 18.7915 9.15373 18.5487 9.18551 18.3037L9.52105 15.7179L7.72969 13.8232C7.55998 13.6437 7.50188 13.3858 7.57822 13.1508C7.65455 12.9159 7.85313 12.7414 8.09594 12.696L10.6589 12.216L11.9073 9.92683C12.0256 9.70995 12.2529 9.57501 12.4999 9.57501ZM12.4999 11.6598L11.6907 13.1437C11.5936 13.3217 11.4216 13.4467 11.2223 13.484L9.56097 13.7951L10.7222 15.0233C10.8615 15.1706 10.9271 15.3728 10.9011 15.5739L10.6836 17.25L12.2105 16.5252C12.3937 16.4383 12.6062 16.4383 12.7894 16.5252L14.3163 17.25L14.0988 15.5739C14.0727 15.3728 14.1384 15.1706 14.2777 15.0233L15.4389 13.7951L13.7776 13.484C13.5783 13.4467 13.4063 13.3217 13.3092 13.1437L12.4999 11.6598Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.25 3.24997C16.25 2.83576 15.9142 2.49997 15.5 2.49997C15.0858 2.49997 14.75 2.83576 14.75 3.24997V4.49997H11C10.5858 4.49997 10.25 4.83576 10.25 5.24997C10.25 5.66418 10.5858 5.99997 11 5.99997H14.75V7.24997C14.75 7.66418 15.0858 7.99997 15.5 7.99997C15.9142 7.99997 16.25 7.66418 16.25 7.24997V3.24997ZM22.25 11H20.75V20.25C20.75 20.9404 20.1904 21.5 19.5 21.5H5.5C4.80964 21.5 4.25 20.9403 4.25 20.25V11H2.75V20.25C2.75 21.7688 3.98122 23 5.5 23H19.5C21.0188 23 22.25 21.7688 22.25 20.25V11Z"
        />
      </g>
    </svg>
  );
};
